import { majorToMinor, unformat } from '@eventbrite/intl';
import { formValueSelector } from 'redux-form';
import { CHECKOUT_FORM_NAME } from '../constants/checkoutForm';
import { PAYMENT_AMOUNT } from '../containers/checkout/constants';
import { CheckoutState } from '../state';
import { getCurrencyFormat, getDefaultPayinAmount } from './app';
import { getCurrency } from './event';

/**
 * Returns maximum allowed payin amount to fund the event.
 */
export const getMaxAllowedPayin = (state: CheckoutState) => {
    const defaultAmount = getDefaultPayinAmount(state);
    if (defaultAmount) {
        return majorToMinor(defaultAmount, getCurrency(state));
    }

    return state.app.payins?.maxAllowedPayin;
};

/**
 * Returns amount input by user to fund the event.
 */
export const getSelectedAmountToFund = (state: CheckoutState) => {
    const defaultAmount = getDefaultPayinAmount(state);
    if (defaultAmount) {
        return unformat(
            majorToMinor(defaultAmount, getCurrency(state)),
            getCurrencyFormat(state),
        );
    }

    const fieldValuesSelector = formValueSelector(CHECKOUT_FORM_NAME);
    const formattedAmount = fieldValuesSelector(state, PAYMENT_AMOUNT);

    const numericAmount = unformat(
        formattedAmount || '',
        getCurrencyFormat(state),
    );

    return numericAmount;
};

/**
 * Returns available payment methods for a pay in, taken from global state
 */
export const getAvailablePaymentMethods = (_state: CheckoutState) => {
    // TODO: Take these from somewhere, previously it was: orderSelectors.getAvailablePaymentMethods(state.order);
    return [
        {
            type: 'eventbrite',
            instrumentTypes: [
                {
                    variants: ['MASTERCARD', 'VISA', 'AMEX'],
                    type: 'CREDIT_CARD',
                },
                {
                    variants: ['BRAINTREE_PAYPAL'],
                    type: 'NONCE_BRAINTREE',
                },
            ],
        },
    ];
};
